/**
 * Exhaustive Type Checking Helper
 *
 * This function ensures exhaustive handling of discriminated union types.
 * If TypeScript compiles successfully, this function can never be called.
 * If it is called at runtime, it means we have a bug.
 */

/**
 * Assert that a value is never reached
 * Used for exhaustive checking in switch statements
 *
 * @example
 * function handleError(error: AppError) {
 *   switch (error.type) {
 *     case 'NetworkError':
 *       // handle
 *       break;
 *     case 'ValidationError':
 *       // handle
 *       break;
 *     default:
 *       // TypeScript will error if we forget a case
 *       assertNever(error);
 *   }
 * }
 */
export function assertNever(x: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(x)}`);
}
